import { useContext, useMemo } from 'react';

import { EditorContext, useDevPmNodeAttrs } from './../ricos-context';
import type { PmNode } from './/pm-node-types';
import { createThrottle } from './../wix-rich-content-common';
import { findNodeById } from './../tiptap-editor/helpers';

export const useNodeAttrs = <T extends PmNode['type']>(
  nodeId: string,
  nodeType: T
):
  | {
      pmNodeAttrs: OneNode<T>['attrs'];
      patchPmNodeAttrs: (attrs: Partial<OneNode<T>['attrs']>) => void;
    }
  | {
      pmNodeAttrs: undefined;
      patchPmNodeAttrs: undefined;
    } => {
  const { adapter } = useContext(EditorContext);
  const devPmNodeAttrs = useDevPmNodeAttrs();

  if (devPmNodeAttrs) {
    return {
      // @ts-expect-error
      pmNodeAttrs: devPmNodeAttrs as OneNode<T>['attrs'],
      patchPmNodeAttrs: () => {},
    };
  }

  const tr = adapter.tiptapEditor.view.state.tr;
  const nodeWithPos = findNodeById(tr, nodeId);

  const { node } = nodeWithPos?.[0] ?? {};

  if (!node || node.type.name !== nodeType) {
    return { pmNodeAttrs: undefined, patchPmNodeAttrs: undefined };
  }

  const patchPmNodeAttrs = useMemo(
    () =>
      // @ts-ignore $TSFixMe
      createThrottle((attrs: OneNode<T>['attrs']) => {
        adapter.tiptapEditor.commands.updateNodeAttrsById(nodeId, attrs);
      }),
    []
  );

  return {
    // @ts-expect-error issue is fixed in the next typescript versions
    pmNodeAttrs: node.attrs as OneNode<T>['attrs'],
    patchPmNodeAttrs,
  };
};

type OneNode<T extends U['type'], U extends { type: string } = PmNode> = U extends { type: T }
  ? U
  : never;
